export default __webpack_public_path__ + "static/media/outro-img-seal-1.4599d0ef.png";